// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Інтерв’ю» (Interviews, ключ `intv`, група `communications`). */
export const interviewsManifest: IModuleManifest = {
  key: 'intv',
  group: 'communications',
  slug: 'interviews',
  prefix: 'IVW',
  name: { en: 'Interviews', uk: 'Інтерв’ю' },
  entities: [
    { key: 'intv', slug: 'intv', name: { en: 'Interview plans', uk: 'Плани інтерв’ю' }, main: true },
    { key: 'intvmsg', slug: 'intvmsg', name: { en: 'Talking points', uk: 'Тези' }, main: false },
    { key: 'intvobj', slug: 'intvobj', name: { en: 'Objections', uk: 'Заперечення' }, main: false },
    { key: 'intvopp', slug: 'intvopp', name: { en: 'Opponents', uk: 'Опоненти' }, main: false },
    { key: 'intvtask', slug: 'intvtask', name: { en: 'Preparation tasks', uk: 'Підготовчі завдання' }, main: false },
  ],
  loadState: () => import('./state/interviewsSlice').then((m) => m.interviewsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
